<template>
  <div class="page-forgot-account">
    <p class="alert-warning">{{ $t('user.del_tip_title') }}</p>
    <div class="detail">
      <p class="text-title" v-if="username===''">
        {{$t('user.del_tip_logout')}}
        <span class="text-secondary" @click.stop="login()">{{ $t('user.btn_login') }}</span>
      </p>
      <p class="text-title" v-else v-html="$t('user.del_tip_content_1', { username: username })"></p>
      <p v-for="tip in $t('user.del_tip_content')" :key="tip">
        {{ tip }}
      </p>

      <p style="font-size: 1.2rem;">
        [<span @click.stop="deleteUser()" class="text-danger">{{ $t('user.btn_del')}}</span>] &nbsp;&nbsp;
      </p>
     </div>
    <Modal v-model="passwordModal" width="600" :title="$t('user.btn_del')" :transfer="false"
           :footer-hide="true" :mask-closable="false">
      <p class="text-title">
        {{ $t('user.del_confirm') }}
      </p>
      <div class="form-group">
        <Input type="password" id="password" v-model="password" :placeholder="$t('page.login.ph_pwd')">
          <span slot="prepend">{{ $t('page.login.pwd') }}</span>
        </Input>
      </div>
      <div class="form-group-btn">
        <Button type="error" @click.stop="deleteUserConfirm()">{{ $t('user.btn_del') }}</Button>&nbsp;&nbsp;
        <Button type="primary" @click.stop="passwordModal = false">{{ $t('user.btn_cancel') }}
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
    import { DeleteUser } from '@/api/account';

    export default {
        data () {
            return {
                code: 0,
                message: '',
                password: '',
                passwordModal: false
            }
        },
        methods: {
            deleteUser () {
                if (this.$store.state.userinfo) {
                    this.password = ''
                    this.passwordModal = true
                } else {
                    this.$Modal.error({
                        title: this.$t('user.del_tip_logout')
                    });
                }
            },
            deleteUserConfirm () {
                if (this.password === '') {
                    this.$Message.error(this.$t('page.login.ph_pwd'))
                    return
                }
                const data = {
                    password: this.password
                }
                DeleteUser(data).then(() => {
                    this.$store.commit('logout')
                    this.$Modal.success({
                        title: this.$t('user.del_ok'),
                        content: this.$t('user.del_ok_content'),
                        onOk: () => {
                            this.$router.push('/')
                        }
                    });
                }).catch(() => {
                    this.$Modal.error({
                        title: this.$t('user.del_fail'),
                        content: this.$t('user.del_fail_content')
                    });
                })
            },
            login () {
                this.$router.push('/login')
            }
        },
        computed: {
            username () {
                if (this.$store.state.userinfo) {
                    return this.$store.state.userinfo.state_code + '-' + this.$store.state.userinfo.mobile
                } else {
                    return ''
                }
            }
        }
    }
</script>

<style lang="scss">
.page-forgot-account {
  width: 100%;
  margin: 50px auto 0;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .alert-warning {
    padding: 10px;
    width: 100%;
    text-align: center;
    border-radius: 5px;
    background-color: #f8d7da;
    color: #721c24;
    font-size: 1.2rem;
  }

  .detail {
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 5px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    line-height: 2;
    width: 100%;
    max-width: 600px;
    margin-bottom: 20px;
    text-align: center;
    color: #333;
  }
  .text-title {
     font-weight: bold;
     font-size: 1.2rem;
     background-color: #f2f2f2;
     padding: 10px;
     margin-bottom: 10px;
     color: #ed4014;
   }
  .text-danger {
    color: #ed4014;
    font-weight: bold;
    cursor: pointer;
  }
 .text-secondary {
   color: blue;
   font-weight: bold;
   cursor: pointer;
 }
  .form-group-btn {
    margin-top: 80px;
    display: flex;
    justify-content: right;
  }
}
</style>
